<template>
    <loading
        :active.sync="isLoading"
        :can-cancel="false"
        :color="color"
        :is-full-page="is_full_page"
    >
        <template v-slot:after>
            <br />
            <span
                style="
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 15px;
                    position: absolute;"
            >
                <slot name="content"></slot>
            </span>
        </template>
    </loading>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
    name: "LoadingApp",
    props: {
        isLoading: { default: false },
        is_full_page: { default: false }
    },
    components: {
        Loading
    },
    data() {
        return {
            color: "#000"
        };
    },
    created() {
        if (!Object.entries(this.$root.$children).length) {
            return;
        }
        let children = this.$root.$children[0];
        if (children.theme && children.theme.primary_color) {
            this.color = children.theme.primary_color;
        }
    }
};
</script>
